export default {
    DEBUG:false,
    URL_PREFIX:(process.env.NODE_ENV === 'production')?"/api":"",
    IMAGE_BASE_URL:((process.env.NODE_ENV === 'production')?"/api":"")+'/image',
    URL:"https://corona-art-gallery.org",
    EMAIL:"info@globalsocial-network.org",
    STATE_DEFAULT:"Deutschland",
    SHOW_LANDING_PAGE:false
}